export default __webpack_public_path__ + "static/media/enviro-chat.ed7166e5.svg";